module.exports = __webpack_public_path__ + "img/9C5B3B_49200A_E9C8AB_DDAB7D-256px.4346bae2.png";